exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".google-button-black[data-v-a3c2751e]{font-weight:400;background-color:black;display:-ms-inline-flexbox;display:inline-flex;-ms-flex-pack:center;justify-content:center;font-size:18px;border-radius:30px;padding:12px 0;-webkit-box-sizing:border-box;box-sizing:border-box;min-width:200px;min-height:32px;max-height:64px}.google-button-black>.text[data-v-a3c2751e]{color:white;-ms-flex-item-align:center;align-self:center}.google-button-black>.logo[data-v-a3c2751e]{width:32px;margin-left:10px;background:url(\"/assets/google-pay-mark.png\") 0 0 no-repeat;height:20px;background-size:cover;border:none}\n", ""]);

// exports
